module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-klasa6-powtorkomat-4.4da8ff38.jpg";